import login from '../pages/login'
import report from '../pages/report'
import home from '../pages/home'
import refresh from '../pages/refresh'
// import passData from '../pages/dataSearch/passData/passData.vue'
import dataSearch from './dataSearch'
import personManage from './personManage'
import passManage from './passManage'
import setting from './setting'
import main from '../main.vue'

export default [{
  path: '/',
  redirect: {
    name: 'login'
  }
},
{
  path: '/login',
  name: 'login',
  component: login,
  meta: {
    requiresAuth: false
  }
},
{
  path: '/report',
  name: 'report',
  component: report,
  meta: {
    requiresAuth: false
  }
},
{
  path: '/printVisitorQrCode',
  name: 'printVisitorQrCode',
  component: () => import('../pages/personManage/printVisitorQrCode')
},
{
  path: '/eControlCenterProject',
  name: 'eControlCenterProject',
  component: () =>
      import(/* webpackChunkName: 'eControlCenter' */ '../pages/eControlCenter/eControlCenterProject'),
  meta: {
    requiresAuth: false
  }
},
{
  path: '/eControlCenter',
  name: 'eControlCenter',
  component: () =>
      import(/* webpackChunkName: 'eControlCenter' */ '../pages/eControlCenter/eControlCenter'),
  meta: {
    requiresAuth: false
  }
},
{
  path: '/main',
  name: 'main',
  component: main,
  meta: {
    requiresAuth: true
  },
  children: [{
    path: '/main/home',
    name: 'home',
    component: home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/main/refresh',
    name: 'refresh',
    component: refresh,
    meta: {
      requiresAuth: true
    }
  },
  // {
  //   path: '/main/treeTest',
  //   name: 'treeTest',
  //   component: () =>
  //   import(/* webpackChunkName: 'eControlCenter' */ '../pages/treeTest'),
  //   meta: {
  //     requiresAuth: true
  //   }
  // },
    // {
    //   path: '/main/passdata',
    //   name: 'passData',
    //   component: passData,
    //   meta: {
    //     requireAuth: true
    //   }
    // },
  ...dataSearch,
  ...personManage,
  ...passManage,
  ...setting
  ]
}
]



// WEBPACK FOOTER //
// ./src/router/index.js